import { useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';
import { useContentSelector } from '@wajeez-web/stores/content';
import { TextInput } from '@wajeez-web/components/ui';

const tagInitState = {
  name: '',
};

const TagModal = ({
  isOpen,
  onClose,
  data,
  onSubmit,
}: CommonModalProps<Server.CreateTagInput>) => {
  const [tag, setTag] = useState<Server.CreateTagInput>(tagInitState);

  const createTagStatus = useContentSelector(
    ({ tags }) => tags.createTag.status
  );
  const setContentEntityTagsStatus = useContentSelector(
    ({ contentEntity }) => contentEntity.setContentEntityTags.status
  );

  useEffect(() => {
    if (data) {
      setTag({ ...data });
    } else {
      setTag(tagInitState);
    }
  }, [data]);

  return (
    <Modal
      title="Tag"
      withScroll={true}
      open={isOpen}
      onClose={onClose}
      loading={
        createTagStatus === 'loading' ||
        setContentEntityTagsStatus === 'loading'
      }
      onSubmit={() => onSubmit && onSubmit({ ...tag })}
    >
      <div className="space-y-3  ">
        <TextInput
          label="Name"
          name="name"
          value={tag.name}
          onChange={(name, value) => setTag({ name: value })}
          required={true}
        />
      </div>
    </Modal>
  );
};

export default TagModal;
